module.exports = __webpack_public_path__ + "img/cartoes-credito.b054ff10.svg";